import { useMutation, useQueryClient } from 'react-query';
import {
  type AddAndMergeUserProfileBody,
  type AddAndMergeUserProfileResponse,
  addAndMergeUserProfile
} from '../../services/userProfileService';

export function useAddAndMergeUserProfile() {
  const queryClient = useQueryClient();
  return useMutation<AddAndMergeUserProfileResponse, Error, AddAndMergeUserProfileBody>(
    (body) => addAndMergeUserProfile(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('users');
        queryClient.invalidateQueries('userProfile');
        queryClient.invalidateQueries('V1:UserProfilesList');
        queryClient.invalidateQueries(['buddyPreference']);
      }
    }
  );
}
